import { render } from "./Pickup.vue?vue&type=template&id=d4f9ad86&scoped=true"
import script from "./Pickup.vue?vue&type=script&lang=js"
export * from "./Pickup.vue?vue&type=script&lang=js"

import "./Pickup.vue?vue&type=style&index=0&id=d4f9ad86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f9ad86"]])

export default __exports__